import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from "@angular/forms";
import {FormBuilder} from '@angular/forms';

import {MatOptionSelectionChange} from "@angular/material/core";
import Swal from "sweetalert2";
import {Observable, of} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import { MatStepper } from '@angular/material/stepper';
import {DropdownService} from "../../services/dropdown.service";
import {IncidentService} from "../../services/incident.service";
import {DownloadService} from "../../services/download.service";
import {
  AgencyORIList,
  BallisticRecord, BallisticsDeleteReq, CountyCityList,
  icJWT_Account,
  IncidentRecord,
  IncidentSaveEditReq, NJPOPSearchParams, PersonDeleteReq,
  PersonRecord, StateList, WeaponDeleteReq,
  WeaponRecord
} from "../../NIBINInterface";
import {AuthService} from "../../services/auth.service";
import {DialogService} from "../../services/dialog.service";

@Component({
  selector: 'app-incident-form',
  templateUrl: './incident-form.component.html',
  styleUrls: ['./incident-form.component.css'],
  providers: [DropdownService, IncidentService, DownloadService]

})
export class IncidentFormComponent implements OnInit {

  @Input('Incident') data: IncidentRecord = <IncidentRecord>{
    IncidentID:null,
    Inc_State:"NJ",
    Status:'POTENTIAL',
    County:'',
    Inc_City:'',
    Dept:'',
    Persons: <PersonRecord[]>[],
    Weapon:<WeaponRecord[]>[],
    Ballistics:<BallisticRecord[]>[]
  };
  @Output('IncidentShareEdit') IncidentShareEdit = new EventEmitter<IncidentSaveEditReq>()
  requestCopyOfReport: boolean= false


  ddls: any = {
    incTypes: [],
    states: [],
    Caliber:[],
    ItemType:[],
    RelatedArea:[],
    WeaponClassification:[],
    WeaponType:[]
  };
  counties: CountyCityList[] = []
  cities: CountyCityList[] = []
  agencies: AgencyORIList[] = []

  //For The Multiselects on Step 1
  tempIncidents:string[] = []
  tempCaseEvent:string[] = []
  tempNJPOPRejectReason:string[] = []

  showNJPOPDenyReason: boolean= false
  isNJPOP_Or_Reason_Selected: boolean= false
  njpopCounties: CountyCityList[] = []
  njpopCities: CountyCityList[] = []
  njpopAgencies: AgencyORIList[] = []
  njpopQuery: NJPOPSearchParams = <NJPOPSearchParams>{
    county:null,
    city: null,
    agency: null,
    casenumber : null,
    fromDate: null,
    toDate: null
  }
  njpopQueryResult: any[] = []

  pendingDeletedWeapons:WeaponDeleteReq[] = [];
  pendingDeletedBallistics:BallisticsDeleteReq[] = [];
  pendingDeletedPersons:PersonDeleteReq[] = [];
  HoursList: string[] = [];


  //AutoComplete Form Controls
  CNTRL_NJPOP_COUNTY:FormControl = new FormControl();
  CNTRL_NJPOP_CITY:FormControl = new FormControl();
  CNTRL_INC_STATE:FormControl = new FormControl();
  CNTRL_INC_COUNTY:FormControl = new FormControl();
  CNTRL_INC_CITY:FormControl = new FormControl();
  CNTRL_INC_AGENCY:FormControl = new FormControl();
  CNTRL_WPN_CALIBER:FormControl = new FormControl();
  CNTRL_WPN_CLASSIFICATION:FormControl = new FormControl();
  CNTRL_BAL_CALIBER:FormControl = new FormControl();
  CNTRL_BAL_CL_LG:FormControl = new FormControl();
  CNTRL_BAL_CL_TWIST:FormControl = new FormControl();
  CNTRL_BAL_CL_TYPE:FormControl = new FormControl();



  //AutoComplete Filters
  FLTR_NJPOP_COUNTY!: Observable<CountyCityList[]>;
  FLTR_NJPOP_CITY!: Observable<CountyCityList[]>;
  FLTR_INC_STATE!: Observable<StateList[]>;
  FLTR_INC_COUNTY!: Observable<CountyCityList[]>;
  FLTR_INC_CITY!: Observable<CountyCityList[]>;
  FLTR_INC_AGENCY!: Observable<AgencyORIList[]>;
  FLTR_WPN_CALIBER!: Observable<any[]>;
  FLTR_WPN_CLASSIFICATION!: Observable<any[]>;
  FLTR_BAL_CALIBER!: Observable<any[]>;
  FLTR_BAL_CL_LG!: Observable<any[]>;
  FLTR_BAL_CL_TWIST!: Observable<any[]>;
  FLTR_BAL_CL_TYPE!: Observable<any[]>;

  private _FLTR_NJPOP_COUNTY(value: string): CountyCityList[] {
    return (value == null || value?.trim() == '')? this.njpopCounties:this.njpopCounties?.filter(f=>f.County?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_NJPOP_CITY(value: string): CountyCityList[] {
    return (value == null || value?.trim() == '')? this.njpopCities:this.njpopCities?.filter(f=>f.City?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_INC_STATE(value: string): StateList[] {
    return (value == null || value?.trim() == '')? this.ddls.states:this.ddls.states?.filter((f:StateList)=>f.name?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_INC_COUNTY(value: string): CountyCityList[] {
    return (!value || value?.trim() == '')? this.counties:this.counties?.filter(f=>f.County?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_INC_CITY(value: string): CountyCityList[] {
    return (!value || value?.trim() == '')? this.cities:this.cities?.filter(f=>f.City?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_INC_AGENCY(value: string): AgencyORIList[] {
    return (!value || value?.trim() == '')? this.agencies:this.agencies?.filter(f=>f.DeptName?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_WPN_CALIBER(value: string): any[] {
    return (value == null || value?.trim() == '')? this.ddls.Caliber:this.ddls.Caliber?.filter((f:any)=> {
      return f?.DDL_Desc?.toLowerCase().includes(value?.toLowerCase())
    });
  }
  private _FLTR_WPN_CLASSIFICATION(value: string): any[] {
    return (value == null || value?.trim() == '')? this.ddls.WeaponClassification:this.ddls.WeaponClassification?.filter((f:any)=> {
      return f?.DDL_Desc?.toLowerCase().includes(value?.toLowerCase())
    });
  }

  constructor(private authService: AuthService, private dropdownService: DropdownService, private incidentService: IncidentService, public downloadService: DownloadService, private _formBuilder: FormBuilder, private dialogService: DialogService) {
    //if(!localStorage.getItem('SharedEditToken')) //DO NOT RUN for EDIT SHARED LINK
    //  this.user = this.authService.getUser()
    this.loadDDLS()
  }

  SET_FLTR_NJPOP_COUNTY(){
    this.FLTR_NJPOP_COUNTY = this.CNTRL_NJPOP_COUNTY.valueChanges.pipe(startWith(''), map(value => this._FLTR_NJPOP_COUNTY(value)));
  }
  SET_FLTR_NJPOP_CITY(){
    this.FLTR_NJPOP_CITY = this.CNTRL_NJPOP_CITY.valueChanges.pipe(startWith(''), map(value => this._FLTR_NJPOP_CITY(value)));
  }
  SET_FLTR_INC_STATE(){
    this.FLTR_INC_STATE = this.CNTRL_INC_STATE.valueChanges.pipe(startWith(''), map(value => this._FLTR_INC_STATE(value)));
  }
  SET_FLTR_INC_COUNTY(){
    this.FLTR_INC_COUNTY = this.CNTRL_INC_COUNTY.valueChanges.pipe(startWith(''), map(value => this._FLTR_INC_COUNTY(value)));
  }
  SET_FLTR_INC_CITY(){
    this.FLTR_INC_CITY = this.CNTRL_INC_CITY.valueChanges.pipe(startWith(''), map(value => this._FLTR_INC_CITY(value)));
  }
  SET_FLTR_INC_AGENCY(){
    this.FLTR_INC_AGENCY = this.CNTRL_INC_AGENCY.valueChanges.pipe(startWith(''), map(value => this._FLTR_INC_AGENCY(value)));
  }
  SET_FLTR_WPN_CALIBER(){
    this.FLTR_WPN_CALIBER = this.CNTRL_WPN_CALIBER.valueChanges.pipe(startWith(''), map(value => this._FLTR_WPN_CALIBER(value)));
  }
  SET_FLTR_WPN_CLASSIFICATION(){
    this.FLTR_WPN_CLASSIFICATION = this.CNTRL_WPN_CLASSIFICATION.valueChanges.pipe(startWith(''), map(value => this._FLTR_WPN_CLASSIFICATION(value)));
  }
  ngOnInit(): void {

    this.SET_FLTR_NJPOP_COUNTY()
    this.SET_FLTR_NJPOP_CITY()
    this.SET_FLTR_INC_STATE()
    this.SET_FLTR_INC_COUNTY()
    this.SET_FLTR_INC_CITY()
    this.SET_FLTR_INC_AGENCY()
    this.SET_FLTR_WPN_CALIBER()
    this.SET_FLTR_WPN_CLASSIFICATION()


    this.HoursList = this.dropdownService.getHoursArray();

    this.updateAgencyList()
    this.updateCountyList()
    this.updateCityAgencyList()

    if(this.data.Inc_Type)
      this.tempIncidents = this.data.Inc_Type.split(',')
    if(this.data.Inc_RelatedArea)
      this.tempCaseEvent = this.data.Inc_RelatedArea.split(',')
    if(this.data.NJPOPRejectReason) {
      this.tempNJPOPRejectReason = this.data.NJPOPRejectReason.split(',')
    }

    if(this.data.NJPopNo!= null || this.data.NJPOPRejectReason!=null) {
      this.isNJPOP_Or_Reason_Selected = true
      this.showNJPOPDenyReason = true
    }
  }

  addMissingDDLFromInc(){
    let DBEntry =
      {
        ID:0,
        County:this.data.County,
        City:this.data.Inc_City,
        State:this.data.Inc_State,
      }

    if (!(this.counties.some(e => e.County === this.data.County))) {
      this.counties.push(DBEntry)
    }
    if (!(this.cities.some(e => e.County === this.data.Inc_City))) {
      this.cities.push(DBEntry)
    }
    if (!(this.agencies.some(e => e.DeptName === this.data.Dept))) {
      this.agencies.push({
        DeptORI:this.data.DeptORI,
        State: this.data.Inc_State,
        DeptName:this.data.Dept
      })
    }



  }

  async loadDDLS():Promise<void>{
    this.ddls.incTypes = await this.dropdownService.getDDL("IncidentType")
    this.ddls.Caliber = await this.dropdownService.getDDL("Caliber")
    this.ddls.ItemType = await this.dropdownService.getDDL("ItemType")
    this.ddls.RelatedArea = await this.dropdownService.getDDL("RelatedArea")
    this.ddls.WeaponClassification = await this.dropdownService.getDDL("WeaponClassification")
    this.ddls.WeaponType = await this.dropdownService.getDDL("WeaponType")
    this.ddls.states = await this.dropdownService.getStates()

    if (this.data.Inc_State != null) {
      this.counties = await this.dropdownService.getCountyForState(this.data.Inc_State)
    }else {
      this.counties = await this.dropdownService.getCountyForState('NJ')
    }
  }

  savedIncidentEditLink(){
    this.data.Inc_Type = this.tempIncidents.join(',')
    this.data.Inc_RelatedArea = this.tempCaseEvent?.length > 0 ? this.tempCaseEvent.join(',') : null;
    this.data.NJPOPRejectReason = this.tempNJPOPRejectReason?.length > 0 ? this.tempNJPOPRejectReason.join(','): null;

    let req : IncidentSaveEditReq = {
      IncidentRecord: this.data,
      WeaponDeleteReqs: this.pendingDeletedWeapons,
      BallisticsDeleteReqs: this.pendingDeletedBallistics,
      PersonDeleteReqs: this.pendingDeletedPersons,
      RequestCopy: this.requestCopyOfReport,
    }

    this.IncidentShareEdit.emit(req)
  }

  addWeaponRecord() {
    this.data.Weapon?.unshift({
      CALIBER: null,
      CT_Ghost_Gun: false,
      SearModifyFlag:false,
      EvidenceMarker: null,
      ID: null,
      IDENTIFYING_MARKS: null,
      IMPORTER_NAME: null,
      IncidentID: null,
      MAKE: null,
      MANUFACTURER: null,
      MANUFACTURER_NAME: null,
      MODEL: null,
      Notes: null,
      OBLITERATED_INDICATOR: null,
      ORIGIN: null,
      ORIGIN_COUNTRY_NAME: null,
      REC_TIME_TO_CRIME: null,
      RGID_Number: null,
      RGID_State: null,
      SERIAL_NUMBER: null,
      W_CLASS: null,
      W_TYPE: null,
      W_TYPE_DESC: null,
      DTOFCOLLECTION: this.data.OccurrenceDate,
      DTOFSUBMISSION: null,
      PreviousHit: null,
    })

  }

  deleteWeaponRecord(w:WeaponRecord) {
    if(w.ID)
      this.pendingDeletedWeapons.push({IncidentID: this.data.IncidentID, WeaponID: w.ID})

    this.data.Weapon?.splice(this.data.Weapon?.indexOf(w),1)
  }

  setWeaponCheck(checked: boolean, weapon: WeaponRecord) {
    weapon.CT_Ghost_Gun = (checked)
  }
  setSearModifyFlag(checked: boolean, weapon: WeaponRecord) {
    weapon.SearModifyFlag = (checked)
  }

  addBallisticsRecord(type:string) {
    this.data.Ballistics?.unshift({
      CL_LG: null,
      CL_Twist: null,
      CL_Type: null,
      Caliber_Type: null,
      EvidenceMarker: null,
      Headstamp: null,
      ID: null,
      IncidentID: null,
      Item_Quantity: null,
      Item_Type: null,
      Notes: null,
      VGID_CPart: type,
      VGID_Number: null,
      VGID_State: null,
      VGID_Status: null,
      DTOFCOLLECTION: this.data.OccurrenceDate,
      DTOFSUBMISSION: null,
      PreviousHit: null,
    })
  }
  deleteBallisticsRecord(b:BallisticRecord) {
    if(b.ID)
      this.pendingDeletedBallistics.push({IncidentID: this.data.IncidentID, BallisticID: b.ID})

    this.data.Ballistics?.splice(this.data.Ballistics?.indexOf(b),1)
  }

  addPersonRecord() {
    this.data.Persons?.unshift({
      AdditionalNotes: null,
      Address: null,
      Age: null,
      DOB: null,
      Email: null,
      FBI: null,
      FIRSTNAME: null,
      ID: null,
      IncidentID: null,
      LASTNAME: null,
      MI: null,
      Phone: null,
      Rank: null,
      Relationship: null,
      Role: null,
      SBINo: null,
      SBIState: null,
      Sex: null,
      Suffix: null
    })
  }

  deletePersonRecord(p:PersonRecord) {
    if(p.ID)
      this.pendingDeletedPersons.push({IncidentID: this.data.IncidentID, PersonID: p.ID})
    this.data.Persons?.splice(this.data.Persons?.indexOf(p),1)
  }


  async updateCityAgencyList()  {
    if (this.data.Inc_State != null && this.data.County != null) {
      this.dropdownService.getCityForAgencyAndCountyAndState(this.data.County,this.data.Inc_State, this.data.Dept).then(r=>{
        this.cities=r;
        this.addMissingDDLFromInc();
        this.cities = this.cities.sort(function(a, b){
          if(a.City && b.City){
            return a.City.localeCompare(b.City)
          }
          return 0;
        })
        this.SET_FLTR_INC_CITY()
      })
    }
  }

  selectIncidentChange(event: MatOptionSelectionChange) {
    //DEBUG MORE, MIGHT HAVE BUGS. Not Used for Submitting as we take the temp array and join it to a string.
    let p:string = event.source.value;
    let temp:string[] = this.data.Inc_Type? this.data.Inc_Type?.split(','):[]

    if(temp.indexOf(p) == -1){
      temp.push(p)
      this.data.Inc_Type = temp.join(',')
    }else {
      temp.splice(temp.indexOf(p),1)
      this.data.Inc_Type = temp.join(',')
    }
  }

  selectCaseEventChange(event: MatOptionSelectionChange) {

  }

  async updateNJPOPCity() {
    if (this.njpopQuery.county != null) {
      this.dropdownService.getNJPOPCityForCountyAndState(this.njpopQuery.county,'NJ').then(r=>{this.njpopCities=r})
      this.dropdownService.getNJPOPAgencyForCountyAndState(this.njpopQuery.county,'NJ').then(r=>{this.njpopAgencies=r})
      this.SET_FLTR_NJPOP_CITY()
    }
  }

  async updateCountyList() {
    if (this.data.Inc_State != null){
      //this.counties = await this.dropdownService.getCountyForState(this.data.Inc_State)
      this.counties = await this.dropdownService.getCountyForAgencyAndState(this.data.Inc_State, this.data.Dept)

      this.counties = this.counties.sort(function(a, b){
        if(a.County && b.County){
          return a.County.localeCompare(b.County)
        }
        return 0;
      })

      this.SET_FLTR_INC_COUNTY()

    }
  }

  async updateAgencyList() {
    if (this.data.Inc_State != null){
      this.dropdownService.getAgencyForState(this.data.Inc_State).then(r=>{
        this.agencies=r;
        this.addMissingDDLFromInc();
        this.agencies.sort(function(a, b){
          if(a.DeptName && b.DeptName){
            return a.DeptName.localeCompare(b.DeptName)
          }
          return 0;
        })
        this.SET_FLTR_INC_AGENCY();
      })

    }

  }


  clearIncidentCounty() {
    this.data.County = null
  }

  clearIncidentCity() {
    this.data.Inc_City = null
  }
  clearIncidentAgency() {
    this.data.Dept = null
    this.data.Inc_City = null
    this.data.County = null
  }

  clearIncidentTime() {
    this.data.OccurrenceTime = '00:00'
  }

  updateIncidentORI($event: MatAutocompleteSelectedEvent) {
    //Update the ORI
    let oriObj = this.agencies.find(o => o.DeptName==$event.option.value)
    if(oriObj){
      if(oriObj.DeptORI)
        this.data.DeptORI = oriObj.DeptORI
    }

    this.updateCountyList()

  }


  setRequestCopyCheck(checked: boolean) {
    this.requestCopyOfReport = checked;
  }
}
